import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Form,
  Select,
  Row,
  Button,
  Col,
  Input,
  DatePicker,
  message,
  Modal,
} from "antd";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";
import Detail from "./detail";
import Edit from "./edit";

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index + 1,
      name: "夏尔预约试驾详情页",
      type: "达人分享",
      abstract:
        "捷途山海L9，是捷途汽车全新打造的新能源序列首款产品，产品定位“大家庭大七座超混SUV”，搭载奇瑞鲲鹏超能混动C-DM技术，主打空间大、油耗省、动力强的产品优势，覆盖家庭旅行混动出行的使用场景。",
      status: "热评中",
      ranking: "567",
      score: 5,
      downloadCount: "188",
      repostCount: "366",
      referenceCount: "135",
      author: "晓梦",
      releaseDate: "2024-07-24 09:56:25",
      modifyDate: "2024-08-11 09:56:25",
      endDate: "2025-6-20 13:20:11",
      pv: 1888999,
      uv: 678877,
    };
  });

const ContentLibrary = () => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({ total: 20, dataSource: mockData });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.releaseDate) {
      formData.releaseDateStart = moment(formData.releaseDate[0]).format(
        "YYYY-MM-DD"
      );
      formData.releaseDateEnd = moment(formData.releaseDate[1]).format(
        "YYYY-MM-DD"
      );
      formData.releaseDate = undefined;
    }
    axios
      .post(`${localhost}/manage/distributionManage/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const onDelete = (id) => {
    Modal.confirm({
      content: "请确认是否删除当前数据",
      onOk() {
        axios
          .get(`${localhost}/manage/work/delete?id=${id}`)
          .then((res) => {
            message.success("删除成功！");
            setPageInfo({ pageNo: 1, pageSize: 10 });
            getData();
          })
          .catch((error) => {
            message.error("网络异常，请重试！");
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const formStyle = {
    maxWidth: "none",
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      minWidth: 100,
    },
    {
      title: "名称",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      minWidth: 100,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "浏览量(PV)",
      dataIndex: "pv",
      minWidth: 140,
    },
    {
      title: "浏览量(UV)",
      dataIndex: "uv",
      minWidth: 140,
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      minWidth: 100,
    },
    {
      title: "排名",
      dataIndex: "ranking",
      key: "ranking",
      minWidth: 100,
    },
    {
      title: "‌评分",
      dataIndex: "score",
      key: "score",
      minWidth: 100,
    },
    {
      title: "下载量",
      dataIndex: "downloadCount",
      key: "downloadCount",
      minWidth: 100,
    },
    {
      title: "转发量",
      dataIndex: "repostCount",
      key: "repostCount",
      minWidth: 100,
    },
    {
      title: "引用次数",
      dataIndex: "referenceCount",
      key: "referenceCount",
      minWidth: 120,
    },
    {
      title: "作者",
      dataIndex: "author",
      key: "author",
      minWidth: 120,
    },
    {
      title: "发布时间",
      dataIndex: "releaseDate",
      key: "releaseDate",
      minWidth: 120,
    },
    {
      title: "更新时间‌",
      dataIndex: "modifyDate",
      key: "modifyDate",
      minWidth: 120,
    },
    {
      title: "结束时间",
      dataIndex: "endDate",
      key: "endDate",
      minWidth: 120,
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      minWidth: 120,
      render: (_, record) => (
        <Space size="middle">
          <Detail id={record} />
          <Edit id={record} />
          <a onClick={() => onDelete(record.id)}>删除</a>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Form
          form={form}
          name="advanced_search"
          style={formStyle}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="name" label="作品名称">
                <Input placeholder="请输入作品名称" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="status" label="状态">
                <Select placeholder="请选择状态" allowClear>
                  <Select.Option value="待投放">待投放</Select.Option>
                  <Select.Option value="投放中">投放中</Select.Option>
                  <Select.Option value="已结束">已结束</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="label" label="标签">
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="releaseDate" label="发布时间">
                <DatePicker.RangePicker showTime />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="endDate" label="结束时间">
                <DatePicker.RangePicker showTime />
              </Form.Item>
            </Col>
            <Col span={8}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Table
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
            },
          }}
          dataSource={dataInfo.dataSource}
          // loading={loading}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default ContentLibrary;
